import React from "react"

export const InnspireChatInitialize = (props, callback) => {

    let maxRetryIfInnspireChatReady = 10;
    let room = localStorage.getItem("room")
    let checkedInGuestInfo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") ? JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details")) : null
    let hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "")

    let loginCred = null;

    if (checkedInGuestInfo && !(localStorage.getItem("innSpireChatLoginInit") == "true")) {
        loginCred = {
            "first_name": checkedInGuestInfo[0].guestProfile.firstName ,
            "last_name": checkedInGuestInfo[0].guestProfile.lastName ,
            "reservation_id": checkedInGuestInfo[0].reservationNumber,
            "checkin_date": checkedInGuestInfo[0].checkInDate.split("T")[0],
            'checkout_date': checkedInGuestInfo[0].plannedCheckOutDate.split("T")[0],
            "room": localStorage.getItem("room") || null, 
            "profile_id": checkedInGuestInfo[0].guestProfile.pmsProfileId ,
            "member_id": checkedInGuestInfo[0].memberId 
        }
        
       
        localStorage.setItem("innSpireChatLoginInit", true)
    }
    else if (localStorage.getItem("theKnowUserInfo")){
        const theKnowRequiredFieldsForChat=["firstName","lastName","memberId"];
        const theKnowUserInfo= JSON.parse(localStorage.getItem("theKnowUserInfo"));

        if(theKnowRequiredFieldsForChat.every((field)=>theKnowUserInfo.hasOwnProperty(field))){
        
            loginCred = {
                "first_name": theKnowUserInfo.firstName,
                "last_name":  theKnowUserInfo.lastName,    
                "member_id": theKnowUserInfo.memberId   
            }

            localStorage.setItem("innSpireChatLoginInit", true)
        }
    }
    console.log(loginCred, "loginCredloginCred")

    const script = document.createElement('script');
    script.src = `https://d2785v8v9m8d81.cloudfront.net/chatbot/${room && room !== "null" ? props.freshChatData.login.innspireCBVersion || "latest" : props.freshChatData.logout.innspireCBVersion || "latest"}/chatbot.js`;
    script.async = true;

    script.onload = () => {
        const initializeLibrary = async () => {
            let innSpireChatConfig = { 
                chatApi: room && room !== "null" ? props.freshChatData.login.api_url || null : props.freshChatData.logout.api_url || null,
                api_key: room && room !== "null" ? props.freshChatData.login.webIntegrationId || null : props.freshChatData.logout.webIntegrationId || null,
                hotel: room && room !== "null" ? props.freshChatData.login.hotelName || null : props.freshChatData.logout.hotelName || null,
                theme: {
                    assetBackgroundSelectorColor: props.menuColor.selectorColor,
                    assetFontSelectorColor: props.menuColor.assetFontColor,
                    sendImageInputIcon:props.menuColor.assetFontColor
                },
                device_token: localStorage.getItem("FCM_token") || null,
                device_id: window.device ? window.device.uuid : null,
                device_type: window.device ? window.device.platform : "Web",
                hotel_code: hotel_code,
                creds: loginCred,
                showChatButton: false,
            }

            console.log("Innspire Chat Configs:")
            console.log(innSpireChatConfig);
            window.InnspireCB.config(innSpireChatConfig);
            
            setTimeout(() => {
                window.InnspireCB.chatbot.render()
                props.setChatWidgetInnitialized(true);

                setTimeout(() => {
                    if(sessionStorage.getItem("openInnspireChatBot")){   
                        InnSpireChatShowConversation(props);
                        sessionStorage.removeItem("openInnspireChatBot");
                    }
                }, 2500);
            }, 1000);

            const checkInnspireChatReady = setInterval(() => {

                console.log("checking if InnSpirechat ready")
                maxRetryIfInnspireChatReady--;
                if(maxRetryIfInnspireChatReady <= 0){
                    clearInterval(checkInnspireChatReady);
                }

                window.InnspireCB.chatbot.isReady && window.InnspireCB.chatbot.isReady()
                .then((isInnSpireChatReady) => {
                    if(isInnSpireChatReady){
                        clearInterval(checkInnspireChatReady);
    
                        // getting innspire chat unread message count
                        getInnSpireChatUnreadCount((unreadCount) => {
                            props.setUnreadMessageCountWeb(unreadCount)
                        })
    
                        //updating innspire chat profile image:
                        if(sessionStorage.getItem("innspireChatProfilePhoto")){
                            updateInnSpireChatGuestDetails({photo: sessionStorage.getItem("innspireChatProfilePhoto")});
                            sessionStorage.removeItem("innspireChatProfilePhoto");
                        }
                    }
                })
                .catch((err) => {
                    console.log("something went wrong checking innspirechat state: " + err)
                })
            }, 1000);
            
        }

        initializeLibrary();
    };

    script.onerror = (err) => {
        console.log("Something went wrong while initalising innspirechatbot" + JSON.stringify(err))
    }

    callback(true);
    document.head.appendChild(script);
}

export const updateInnSpireChatGuestDetails = (data) => {
    if(window.InnspireCB) window.InnspireCB.chatbot.updateGuestDetails(data);
}

export const getInnSpireChatUnreadCount = (callback) => {

    if(window.InnspireCB){
        window.InnspireCB.chatbot.get_msg_stat()
        .then((res) => {
            callback(+res.unread_msg_count)
        })
        .catch(() => {
            callback(0);
            console.log("error getting innSpireChat unread msg count")
        })
    } else {
        callback(0);
    }
}

export const InnSpireChatShowConversation = (props) => {

    let retry = 1;
    const showChatBot = () => {
        try {
            if(window.InnspireCB) window.InnspireCB.chatbot.show();
    
            setTimeout(() => {
                props.setUnreadMessageCountWeb && props.setUnreadMessageCountWeb(0);
            }, 2000);   
        } catch (error) {
            console.log("error opening innspire chatbot");
            if(retry > 0){
                retry--;
                setTimeout(() => {showChatBot();}, 300);
            }
        }
    }

    showChatBot();
}